import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalStorageModule } from '@max/shared/services/local-storage/local-storage.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { MVMSpinnerBtnModule } from '../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { NmvtisShellModule } from '../titleregistration/nmvtis/components/nmvtis-shell/nmvtis-shell.module';
import { TitleRegistrationCustomerServiceModule } from '../titleregistration/services/titleregistration-customer-service.module';
import { SharedComponentsModule } from './components/shared-components.module';
import { ValidationResultsModule } from './components/validation-results/validation-results.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { LocationService } from './services/location/location.service';
import { LoggingService } from './services/logging/logging.service';
import { FileSaverService } from './services/output/file-saver.service';
import { APP_SETTINGS_PROVIDERS } from './settings/app-settings.model';
import { SharedValidatorsModule } from './validators/shared-validators.module';
import { ToastModule } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';
import { KeyboardService } from './services/keyboard/keyboard.service';

@NgModule({
    imports: [
        AccordionModule,
        AlertModule,
        AutoCompleteModule, // Move it to transactions if not needed?
        BsDropdownModule,
        ButtonsModule,
        CalendarModule,
        CommonModule,
        DropdownModule,
        FileUploadModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        HttpClientModule,
        InputNumberModule,
        LocalStorageModule.withConfig({
            prefix: 'shared-local-storage',
            storageType: 'localStorage'
        }),
        MultiSelectModule,
        MVMSpinnerBtnModule,
        NmvtisShellModule,
        PaginationModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        SharedDirectivesModule,
        SharedPipesModule,
        SharedValidatorsModule,
        TitleRegistrationCustomerServiceModule,
        ValidationResultsModule,
        ToastModule
    ],
    exports: [
        AccordionModule,
        AlertModule,
        AutoCompleteModule,
        BsDropdownModule,
        ButtonsModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        InputNumberModule,
        MultiSelectModule,
        MVMSpinnerBtnModule,
        NmvtisShellModule,
        PaginationModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        SharedDirectivesModule,
        SharedPipesModule,
        SharedValidatorsModule,
        ValidationResultsModule
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                APP_SETTINGS_PROVIDERS,
                FileSaverService,
                FormGroupDirective,
                LocationService,
                LoggingService,
                KeyboardService
            ]
        };
    }
}
